import { useState } from 'react'
import { ZoomDialog, type Action } from '../components'
import { ImageNotFound } from '../assets'

export function useZoomDialog(image?: string, alt?: string) {
  const [zoom, setZoom] = useState(false)
  const zoomImage = image ?? ImageNotFound
  const [zoomAlt, setZoomAlt] = useState<string | undefined>(alt)

  const zoomAction: Action = {
    type: 'zoom',
    title: 'Zoom',
    callback: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
      e.preventDefault()
      setZoom(true)
    },
  }

  return {
    setZoom,
    setZoomAlt,
    ZoomDialog: () => (
      <ZoomDialog
        open={zoom}
        onClose={() => {
          setZoom(false)
        }}
        image={changeWidth(zoomImage)}
        alt={zoomAlt}
      />
    ),
    zoomAction,
  }
}

/** HELPERS */
const changeWidth = (image: string, width = 2000) => image.replace(/width=[\d]+/, `width=${width}`)
